import serverData from './server-data'

const isFeatureEnabled = (featureName) => {
  const { country = '', featureFlags = {} } = serverData
  let featureNameValue = featureFlags[featureName] || ''
  if (featureNameValue !== '') {
    featureNameValue = featureNameValue.replace(/\s|\\/g, '')
    return JSON.parse(featureNameValue).indexOf(country) !== -1
  }
  return false
}

// This function is used to parse the string object
//Ex: dsrRecaptchaSiteKey: "{\"sitekey\":\"6Lfg59kcAAAAAGmFghbonojJugMKZZ7aq9dcu97U\"}"
export const getFeatureValue = (featureName) => {
  const { featureFlags = {} } = serverData
  let featureNameValue = featureFlags[featureName] || ''
  if (featureNameValue !== '') {
    featureNameValue = featureNameValue.replace(/\s|\\/g, '')
    return JSON.parse(featureNameValue)
  }
  return {}
}

export default isFeatureEnabled
